"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Order_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = exports.orderDataEquals = void 0;
const web3_js_1 = require("@solana/web3.js");
const data_source_1 = require("@staratlas/data-source");
/**
 * Check if two instances of `OrderAccount` are equal
 * @param orderData1 - the first instance
 * @param orderData2 - the second instance
 * @returns boolean
 */
function orderDataEquals(orderData1, orderData2) {
    return (orderData1.orderInitializerPubkey === orderData2.orderInitializerPubkey &&
        orderData1.currencyMint === orderData2.currencyMint &&
        orderData1.assetMint === orderData2.assetMint &&
        orderData1.initializerCurrencyTokenAccount ===
            orderData2.initializerCurrencyTokenAccount &&
        orderData1.initializerAssetTokenAccount ===
            orderData2.initializerAssetTokenAccount &&
        orderData1.orderSide === orderData2.orderSide &&
        orderData1.price === orderData2.price &&
        orderData1.orderOriginationQty === orderData2.orderOriginationQty &&
        orderData1.orderRemainingQty === orderData2.orderRemainingQty &&
        orderData1.createdAtTimestamp === orderData2.createdAtTimestamp);
}
exports.orderDataEquals = orderDataEquals;
let Order = Order_1 = class Order {
    constructor(_data, _key) {
        this._data = _data;
        this._key = _key;
    }
    /**
     * Find the `OrderVault` account address
     * @param program - GalacticMarketplace Program
     * @param orderInitializer - the order initializer
     * @param depositMint - the deposit mint
     * @returns PDA and bump
     */
    static getOrderVaultAddress(program, orderInitializer, depositMint) {
        return web3_js_1.PublicKey.findProgramAddressSync([
            Buffer.from('order-vault-account'),
            orderInitializer.toBuffer(),
            depositMint.toBuffer(),
        ], program.programId);
    }
    /**
     * Find the `OrderVaultAuthority` account address
     * @param program - GalacticMarketplace Program
     * @param orderInitializer - the order initializer
     * @returns PDA and bump
     */
    static getOrderVaultAuthorityAddress(program, orderInitializer) {
        return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from('order-vault-auth'), orderInitializer.toBuffer()], program.programId);
    }
    get data() {
        return this._data;
    }
    get key() {
        return this._key;
    }
    static decodeData(account, program) {
        return (0, data_source_1.decodeAccount)(account, program, Order_1);
    }
};
Order.ACCOUNT_NAME = 'orderAccount';
Order.MIN_DATA_SIZE = 8 + // discriminator
    32 + // order initializer pubkey
    32 + // currency mint
    32 + // asset mint
    32 + // initializer currency token account
    32 + // initializer asset token account
    1 + // order side
    8 + // price
    8 + // order origination qty
    8 + // order remaining qty
    8; // created at timestamp
Order = Order_1 = __decorate([
    (0, data_source_1.staticImplements)(),
    __metadata("design:paramtypes", [Object, web3_js_1.PublicKey])
], Order);
exports.Order = Order;
//# sourceMappingURL=orderAccount.js.map